import React, {Component} from 'react';
import styled from 'styled-components';

const Input = styled.input.attrs({
    name: 'formattedPhone',
    type: 'tel',
    placeholder: '(000) 000-0000',
    autoComplete: 'off'

})`
    font-size: inherit;
    background-color: transparent;
    border: none;
    color: #f00;
    width: 7em;
    text-align: center;
    outline-color: transparent;
    
    :focus::-webkit-input-placeholder {
        color: transparent;
    }
`;

class PhoneInput extends Component {
    state = {
        number: '',
        submits: 0
    };

    componentWillReceiveProps(props) {
        if (props.submits !== this.state.submits) {
            this.setState({
                number: '',
                submits: props.submits
            });

            this.props.onValid(false);
        }
    }

    onChange = e => {
        const raw = e.target.value.replace(/\D+/g, '').replace(/^1/, '');

        const [unused, areaCode, prefix, number] = raw.match(/^(\d{0,3})(\d{0,3})(\d{0,4})/) || [];

        let formatted = '';

        if (areaCode)
            formatted = `(${areaCode}`;

        if (prefix)
            formatted = `${formatted}) ${prefix}`;

        if (number)
            formatted = `${formatted}-${number}`;

        this.setState({number: formatted});


        this.props.onValid(raw.length === 10);
    };

    render() {
        const {number} = this.state;

        return (
            <Input onChange={this.onChange} value={number}/>
        )
    }
}

export default PhoneInput;


// WEBPACK FOOTER //
// ./src/PhoneInput.js